import { ContentBox } from "@msuite/ui/app-shell";
import { parseAsStringLiteral, useQueryState } from "@msuite/ui/libs/nuqs";
import { DataTable } from "@msuite/ui/table";
import { MY_INCOMING_INVOICE_APPROVAL_FILTERS } from "@msuite/utils/schemas";
import { useMyIncomingInvoiceApprovals } from "@/hooks/use-my-incoming-invoice-approvals";
import { MyApprovalsFilterPicker } from "./my-approvals-filter-picker";
import { columns } from "./table-config";

/**
 * The caller's own approvals: what still waits on them — the dashboard tile's list in full —
 * or what they decided. The filter sits in the address, so a reload keeps it.
 */
export function IncomingInvoiceApprovals() {
	/** State */
	const [filter, setFilter] = useQueryState(
		"state",
		parseAsStringLiteral(MY_INCOMING_INVOICE_APPROVAL_FILTERS).withDefault("pending"),
	);

	/** Query */
	const { approvals, isLoading, queryKey, refetch } = useMyIncomingInvoiceApprovals(filter);

	/** Render */
	return (
		<ContentBox>
			<DataTable
				data={approvals}
				columns={columns}
				isLoading={isLoading}
				queryKey={queryKey}
				refetch={refetch}
				menu={() => (
					<MyApprovalsFilterPicker
						value={filter}
						onChange={setFilter}
					/>
				)}
				persistenceKey="incoming-invoice-my-approvals-table"
				initialPinningState={{ start: ["number"] }}
			/>
		</ContentBox>
	);
}
